import { makeStyles } from '@material-ui/styles';

export default makeStyles({
  divider: {
    marginLeft: '0.7rem',
    marginRight: '0.7rem',
  },
});
